<div *ngIf="purchasedItemList && purchasedItemList.length > 0; else noPurchase">
  <div class="d-block d-lg-flex pt-lg-4 justify-content-center align-items-center">
    <div class="item-details d-flex flex-column align-items-center flex-grow-1 flex-shrink-1 px-3">
      <div class="d-lg-flex d-block">
        <div class="payment-text">
          <div class="text-success mb-0 font-heading font-size-18 text-left">
            <ng-container *ngIf="isEventItem; else purchaseSuccessTitle">
              {{ 'marketplace.booking.success' | translate : { fgbdefault: 'Booking Successful' } }}
            </ng-container>
            <ng-template #purchaseSuccessTitle>{{ 'marketplace.purchase.success' | translate }}</ng-template>
          </div>
          <p class="mb-0 text-black font-size-14 text-left pe-lg-4 rewards-success-description mt-2">
            <ng-container *ngIf="isEventItem; else purchaseSuccessMessage">
              {{
                'marketplace.booking.email.confirmation'
                  | translate
                    : {
                        fgbdefault:
                          'Thank you for your booking. You will shortly receive an email confirming your booking for this event.'
                      }
              }}
            </ng-container>
            <ng-template #purchaseSuccessMessage>{{ 'marketplace.purchase.email.confirmation' | translate }}</ng-template>
          </p>

          <div class="d-flex justify-content-between border-0 mt-4">
            <a class="btn btn-primary confirm-btn font-heading" [routerLink]="['/rewards/wallet']">{{
              'rewards.back.to.wallet' | translate
            }}</a>
          </div>
        </div>

        <div class="payment-details">
          <div *ngFor="let purchasedItem of purchasedItemList">
            <div class="purchase-summary">
              <div class="image-wrap">
                <img
                  class="purchase-success-image"
                  src="{{ purchasedItem.ItemImageURL | contentImage : '7' : 'marketplace' }}"
                  alt="{{ purchasedItem.ImageURL }}"
                  [useDefault]="true"
                  loyaltyType="marketplace"
                  draggable="false"
                />
              </div>
              <div class="purchase-details">
                <div class="font-size-14 font-heading purchase-summary-name first-text-capitalize">
                  {{ purchasedItem.DisplayName || 'Display Name' }}
                </div>
                <div class="purchase-summary-rows">
                  <!--Attributes-->
                  <ng-container *ngFor="let attribute of attributes">
                    <div class="purchase-summary-row">
                      <span class="font-size-12 rewards-details-spacing">{{ attribute.AttributeName }}:</span>
                      <span
                        class="font-heading font-size-14"
                        fgbclAttributeTransValue
                        [attributeList]="purchasedItem.Attributes"
                        [attributeDataOrId]="attribute.RewardValueId"
                      ></span>
                    </div>
                  </ng-container>
                  <!--Custom Fields-->
                  <ng-container *ngFor="let customfield of customFields">
                    <div class="purchase-summary-row">
                      <span class="font-size-12 rewards-details-spacing">{{ customfield.DisplayName }}:</span>
                      <span class="font-heading font-size-14"> {{ customfield.Value }}</span>
                    </div>
                  </ng-container>
                  <!--Quantity-->
                  <div class="purchase-summary-row">
                    <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.quantity' | translate }}</span>
                    <span class="font-heading font-size-14">{{ quantity || purchasedItem.ItemCount }}</span>
                  </div>
                  <!--Price-->
                  <ng-container *inPopulation="[populations.Default]">
                    <div class="purchase-summary-row point-value-section" *ngIf="purchasedItem.EcashValue <= 0">
                      <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.points.used' | translate }}</span>
                      <span *ngIf="price > 0" class="font-heading font-size-14"
                        >{{ price | number }} {{ 'marketplace.points.value.pts' | translate }}</span
                      >
                      <span *ngIf="price == 0" class="font-heading font-size-14">
                        {{ 'fgbcl.marketplace.item.free' | translate }}</span
                      >
                    </div>
                  </ng-container>
                  <!--Ecash-->
                  <div class="purchase-summary-row" *ngIf="purchasedItem.EcashValue > 0">
                    <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.ecash.used' | translate }}</span>
                    <span class="font-heading font-size-14">{{
                      (quantity * purchasedItem.EcashValue) / 100 | FortressCurrencyPipe
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngFor="let purchasedItem of purchasedItemList">
              <div class="mx-auto mb-2 mt-3 border-0" *ngIf="purchasedItem.ProcessProviderId == ProcessProvider.Download">
                <a
                  class="d-flex align-items-center justify-content-center btn btn-secondary w-100 confirm-btn font-heading text-black border-none bg-primary"
                  (click)="downloadPurchasedItem(purchasedItemLogId)"
                >
                  <span class="font-size-14 text-white">{{ 'download.rewards.item' | translate }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noPurchase>
  <div class="text-center m-5">{{ 'no.purchased.item.found' | translate }}</div>
</ng-template>
